module.exports = __webpack_public_path__ + "img/Bitmap.95df54bf.png";